var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_528_90)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_528_90",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_528_90",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_528_90",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC70lEQVR4nO2XPW8TMRjHDQ1ioIWJl4EBCYTKwITESxZzj69VSgeEUCSgsQ8KBBa+AmUCZlr4EkwtFRJDoUM7sCEEBQlY6AsLUpFAZPwj+9yQhJRcLr5cEPeXLF0UPbZ/fl7sh7EmghKLUAI9MSQtsLhKffOqfmQg6AEvIPNIjdL2ADKPNChtDyDzSIP+K48wh8pAWintUEKW7A1K2wPIPNKgrGrFVBZarZR2ciNL9gYlesKSPkOKSQSigGB4EKWhHWbob0UjUGIKSizX23kHWRy5cjdKHkGK9RBArEDRNRSLfS3tOM9B+tchadXarkMKPxUQKPIgRcVuZBrj+YG29zGeH4ASM3aOStswbsOJHmBiYmu7EBvStiYUNzxT4odYVLnLB/E0SihFhJm2c76MfDCOIFbihNNmwlhhJxSt2bmD7oGU6Go4F52LY8+a7SsQZRuuS5G8En8h/2S1xBaLfSgf2/ZnKe0AhOtqpqufPigvnxyIonvW9ZPmtxRn43qUbbo3emjXuO8E5O+DRlhCQuCPWpDnyYNIcTg5kOFBG76ryYMUeX9iIEXebw+rkjyIw7LbvAybdb4nl+ySPiUeWtI/YvfwIUEQ8aw22SHFY+dVK7DJrmjeCUiLMWVBAucgkh5Zr9/pBsiyubxuFbZXn+KuL0QpTnUDBLqfYI4FSTft/G+dPVFag9Cq00dj2d8FKb6E83sXoxm5AAnHTCe9SP0znmbtnIuRWwOHIObd1XFjpUwfr738DQE/EN3YJYgZ9ERfZPHCiWZrDuUjAr4vRRADs2b6Cc5zLdfnPAdFN37nBH2FEu/t9xIu0N5oIJIWkoGxnaO+C6R3xtzS+u2kh/4O/NHwP1tiw3B6gTG+H1cKuyHpdbVqRYVxqTBZ/UvmNKNDv0IgztfmV0/AVDdTOn0Cku7qfsKe/E8o+qHfTlA0D0m3oeg4GNvS1L4WRoo3KA3tYf+qUAdD79oqAL0m1IfZXNr76UgGRok5XPaP/gI8Qq4frfQeRgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.140305bfc1c6d7e3b61616f2bdb4c374.svg";
export { ForwardRef as ReactComponent };